import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogComponent } from '@vsolv/vectors-ui/dialog';
import { EvaluatedAddon } from '../../components';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-preview-group-addons',
  templateUrl: './preview-group-addons.dialog.html',
  standalone: false,
})
export class PreviewGroupAddonsDialog {
  @ViewChild(DialogComponent) dialog?: DialogComponent;

  @Input() addon: EvaluatedAddon | null = null;
  @Input() selectedAddon = 0;
  @Input() hideDeductibleAndLiabilityLimit = false;
  @Input() checked = false;

  @Output() selected = new EventEmitter<boolean>();

  open() {
    this.dialog?.open();
  }
}
